import { render, staticRenderFns } from "./SpaFormPdf.vue?vue&type=template&id=0b080183&scoped=true"
import script from "./SpaFormPdf.vue?vue&type=script&lang=js"
export * from "./SpaFormPdf.vue?vue&type=script&lang=js"
import style0 from "./SpaFormPdf.vue?vue&type=style&index=0&id=0b080183&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b080183",
  null
  
)

export default component.exports